<template>
  <media-widget
    :name="props.name"
    :id="props.id"
    :value="props.value"
  />
</template>

<script>
  import MediaWidget from './MediaWidget';

  export default {
    props: ['props'],

    components: {
      MediaWidget,
    },
  };
</script>
